// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Pancard Update Start ************************/
export const pancardUpdateDetails = (updatePancardData: any) => {
	const data = {
		PancardDetailsToken: updatePancardData,
	};
	const url = `${API_URL}updatePancardDetails`;
	return makeApiCall(url, data);
};
/** ***************** Pancard Update End ************************/
